// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1YdRZ","additionalInfo":"AgreementModal_additionalInfo__1Ujzf"};